import React, { createContext, Dispatch, useContext } from 'react';
import {
  ActionBase,
  BnSelectedStateProvider,
  Selector,
  StateBase,
  UseSelectedState,
} from '~/common/bn-context/bn-selected-state-provider';

export function initializeStateContext<S extends StateBase, A extends ActionBase>() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const State = createContext<S>(undefined!);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const UseSelectedState = createContext<UseSelectedState<S>>(undefined!);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const Dispatch = createContext<Dispatch<A>>(undefined!);
  const Provider = createBnContextProvider(State, UseSelectedState, Dispatch);

  function useSelectedState<R>(selector: Selector<S, R>, isEqual?: (oldSelection: R, newSelection: R) => boolean) {
    return useContext(UseSelectedState)(selector, isEqual);
  }

  return {
    Provider,
    State,
    Dispatch,
    useSelectedState,
  };
}

function createBnContextProvider<S extends StateBase, A extends ActionBase>(StateContext: React.Context<S>, SelectorContext: React.Context<UseSelectedState<S>>, DispatchContext: React.Context<Dispatch<A>>) {
  return function BnStateContextProvider({ state, dispatch, children }: { state: S, dispatch: Dispatch<A>, children: React.ReactNode }) {
    return (
      <StateContext.Provider value={state}>
        <DispatchContext.Provider value={dispatch}>
          <BnSelectedStateProvider state={state} UseSelectedStateContext={SelectorContext}>
            {children}
          </BnSelectedStateProvider>
        </DispatchContext.Provider>
      </StateContext.Provider>
    );
  };
}
